import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';
import Image from './asset.png';
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
    marginBottom: theme.spacing(5)
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0
  },
  textField: {
    minWidth: '62%'
  },
  checkButton: {
    marginLeft: '2%',
    float: 'right'
  },
  image: {
    height: '150px',
    marginRight: '2%'
  },
  submitButton: {
    minWidth: '100%',
  },
  loading: {
    border: '10px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '10px solid #3498db',
    width: '100px',
    height: '100px',
    animation: '$spin 2s linear infinite'
  },
  '@-webkit-keyframes spin': {
    '0%': {
        webkitTransform: 'rotate(0deg)'
    },
    '100%': {
        webkitTransform: 'rotate(360deg)'
    }
  },
  '@keyframes spin': {
      '0%': {
          transform: 'rotate(0deg)'
      },
      '100%': {
          transform: 'rotate(360deg)'
      }
  }
}));

export default function Return() {
  const classes = useStyles();
  const [siteid, setSiteID] = useState('');
  const [sitename, setSiteName] = useState('');
  const [room, setRoom] = useState('');
  const [assetNo, setAssetNo] = useState('');
  var subState = "";
  const [error, setError] = useState(false);
  const [alert, setAlert] = useState();
  const [loading, setLoading] = useState();
  const [submitReturnUI, setSubmitReturnUI] = useState();
  const [checked, setChecked] = useState(false);
  const [locationObjects, setLocationObjects] = useState(["", "Library", "Reception"]); 
  const handleDropDownChange = (event) => {
    switch(event.target.name)
    {
      case "ddlSite":
        setLocationObjects(["", "Library", "Reception"]);
        switch(event.target.value)
        {
          case "10": 
            setSiteName("Broomfield Hall");
            break;
          case "9":
            setSiteName("Ilkeston Campus");
            break;
          case "6":
            setSiteName("Joseph Wright Centre");
            break;
          case "3":
            setSiteName("Johnson Building");
            setLocationObjects(["", "Reception"]);
            break;
          case "1":
            setSiteName("Roundhouse"); 
            break;
          default:
        }
        setSiteID(event.target.value);
        break;
      case "ddlLocation":
        setRoom(event.target.value);
        break;
      default:
    }
  };
  const handleTextChange = (event) => {
    switch(event.target.id)
    {
      case "txtAssetNo":
        setAssetNo(event.target.value);
        break;
      case "chkPowerReturned":
        setChecked(event.target.checked);
        break;
      default:
    }
  };
  const CheckAsset = () => {
    if(assetNo.length !== 5)
    {
      setError(true);
      return;
    }
    setError(false);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    setLoading(<Container className={classes.loading}></Container>);
    fetch("https://lapsafeapi.azurewebsites.net/api/hornbill?AssetNo=DC0" + assetNo, requestOptions).then(response => response.json()).then((data) => {
      try{
        if(data.Message === "An error has occurred.")
        {
          setAlert(<Alert severity="error">Unfortunately, there has been an error on our end. If this problem persists please log a job: <a href="https://service.hornbill.com/derbycollege">Click Here</a>. Please ensure that you quote the asset number as there's likely an issue with that exact device.</Alert>)
          return;
        }

      } catch {} 
      setLoading();
      if(data.Type !== "Student Loan Fleet" && data.Type !== "Student (Offsite Loan)")
      {
        setAlert(<Alert severity="error">Unfortunately, the laptop you have entered isn't what is expected. Please log a job: <a href="https://service.hornbill.com/derbycollege">Click Here</a></Alert>)
        return;
      }
      subState = data.Type;
      setAlert();
      setSubmitReturnUI(<Button variant="contained" color="primary" className={classes.SubmitButton} onClick={SubmitReturn}>Return Device</Button>);
    });  
  };
  const SubmitReturn = () => {
	  var substateID = "";
	  subState === "Student Loan Fleet" ? substateID = "11" : substateID = "12";
    var Data = {
      assetid: "DC0"+ assetNo,
      sitename: sitename,
      siteid: siteid,
      room: room,
      powersupply: checked,
	  substate: subState + " Return",
	  substateid: substateID
    };
    setLoading(<Container className={classes.loading}></Container>);
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Data)
    };
    fetch("https://lapsafeapi.azurewebsites.net/api/laptopreturns?HornbillKey=3rWD1!85jKJ", requestOptions).then(response => response.json()).then((data) => {
      setLoading();
      if(data.Message === "Device Updated and job has been logged to the respective team.")
      {
        setAlert(<Alert severity="success">{data.Message}</Alert>);
      }
    });
  };
    return (
      <Container className={classes.container}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="ddlSitelbl">Site</InputLabel>
          <Select labelId="ddlSitelbl" name="ddlSite" value={siteid} onChange={handleDropDownChange} label="Site">
            <MenuItem key={1} value=""><em>None</em></MenuItem>
            <MenuItem key={2} value="10">Broomfield Hall</MenuItem>
            <MenuItem key={3} value="9">Ilkeston Campus</MenuItem>
            <MenuItem key={4} value="3">Johnson Building</MenuItem>
            <MenuItem key={5} value="6">Joseph Wright Centre</MenuItem>
            <MenuItem key={6} value="1">Roundhouse</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="ddlLocationlbl">Location</InputLabel>
          <Select labelId="ddlLocationlbl" name="ddlLocation" value={room} onChange={handleDropDownChange} label="Location">
            {locationObjects.map((object, i) => {
              return (<MenuItem key={i} value={object}>{object === "" ? <em>None</em> : object}</MenuItem>)
            })}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <FormControlLabel
            control={<Checkbox id="chkPowerReturned" checked={checked} onChange={handleTextChange} />}
            label="Please select if a power supply has not been returned"
          />
        </FormControl>
        <Typography>Please enter the asset number which is a sticker on the bottom of the laptop, it looks like the image here:</Typography>
        <Container className={classes.textContainer}>
          <img src={Image} alt="Derby College Asset Tag" className={classes.image}></img>
          <TextField id="txtAssetNo" label="Asset No" error={error} className={classes.textField} variant="outlined" onChange={handleTextChange}/>
          <Button variant="contained" color="primary" className={classes.checkButton} onClick={CheckAsset}>
            Check Asset
          </Button>
        </Container>
        {submitReturnUI}
        {loading}
        {alert}
      </Container>
  );
}